// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"87fdd61c","750":"3835a0d8","787":"51cbd20a","803":"fcf529c6","981":"72215476"}[chunkId] + ".chunk.js";
};